import { SLIDER_TYPES } from 'consts/enum';
import './slider.scss';

const { PERCENTAGE, RATING, NUMBER } = SLIDER_TYPES;

export const SliderTemplate = (model) => {
	const { input_type, userPrompt, minLabel, maxLabel, scale, stepValue, id } = model;
	const { value: maxValue } = maxLabel || {};
	const { value: minValue } = minLabel || {};
	let minimum = 0;
	let maximum = 0;
	let labelsContainer = '';
	let stepValueToUse = stepValue;

	const processStepper = () => {
		if ((parseInt(maxValue) - parseInt(minValue)) % parseInt(stepValue) > 0) {
			if ((parseInt(maxValue) - parseInt(minValue)) % parseInt(stepValue) === 0) {
				maximum = parseInt(maxValue);
			} else {
				const factors = Math.floor((parseInt(maxValue) - parseInt(minValue)) / parseInt(stepValue)) + 1;
				maximum = parseInt(stepValue) * factors + parseInt(minValue);
			}
		}
	};

	switch (input_type) {
		case PERCENTAGE: {
			minimum = minValue;
			maximum = maxValue;

			processStepper();

			/* html */
			labelsContainer = `
			<div class="engt-custom-range-slider__label">
			<span>${minLabel.name}</span>
				<label for="engt-slider-input-${id}" class="engt-custom-range-slider__label" id="engt-slider-val-${id}" style="justify-content: center; margin-bottom: 1px">
					0%
				</label>
			<span>${maxLabel.name}</span>
			</div>`;

			break;
		}
		case RATING: {
			minimum = 1;
			maximum = scale;
			stepValueToUse = 1;

			break;
		}
		case NUMBER: {
			minimum = minValue;
			maximum = maxValue;

			processStepper();

			/* html */
			labelsContainer = `
			<div class="engt-custom-range-slider__label">
				<span>${minLabel.name}</span>
				<span>${maxLabel.name}</span>
			</div>`;

			break;
		}
	}

	/* html */
	const messageContainerHtml = `
		<div class="engt-msg engt-msg-bot engt-msg-slider engt-msg-border-bot" id="engtSliderMsg-${id}">
             <p class="description">${userPrompt}</p>
			 <div class="engt-slider-wrapper">
				 <div class="engt-slider">
					<input type="range" 
						class="engt-slider-input"
						id="engt-slider-input-${id}"
						min=${minimum}
						max=${maximum}
						scale=${scale}
						step=${stepValueToUse}
						value=${minimum}
						data-interactive-field
					/>
					<span class="engt-slider-value-preview"></span>
					${labelsContainer}
				</div>
			</div>
             <confirm-btn></confirm-btn>
             <skip-btn></skip-btn>
        </div>
	`;

	return messageContainerHtml;
};
